<template>
  <div v-loading="coursePlanLoading" class="course-plan-box">
    <div class="plan-header">
      <el-form ref="form" :inline="true" label-width="80px">
        <el-form-item label="自动排课">
          <el-switch v-model="is_auto_plan_lesson" :active-value="1" active-text="开" :inactive-value="0" inactive-text="关"></el-switch>
          <!-- <el-radio-group v-if="is_auto_plan_lesson === 1" v-model="auto_plan_lesson_type" style="margin-left: 30px;">
            <el-radio :label="1">周</el-radio>
            <el-radio :label="2">月</el-radio>
          </el-radio-group> -->
        </el-form-item>
        <!-- <el-form-item label="" style="float:right">
          <el-button type="primary" plain @click="setLastWeekPlan">沿用上周排课计划</el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <el-table v-if="is_auto_plan_lesson === 1" :data="tableData" border height="55vh">
      <el-table-column v-for="(items,index) in datess" :key="index" :field="items.field" align="center" style="width:11.5%">
        <template v-if="index === 0" slot="header">
          <div class="header-div">
            <div class="header-col1">时间段</div>
            <div class="header-col2">周</div>
            <div class="header-line"></div>
          </div>
        </template>
        <template slot="header">{{ items.week }}</template>
        <template slot-scope="scope">
          <div v-if="items.field === 'time'" class="course-all-list">
            {{ scope.row[items.field] }}
          </div>
          <div v-else class="course-all-list">
            <el-button type="text" :style="scope.row[items.field] && scope.row[items.field].name?'':'color:#999;'" @click="siteShow(index,scope.row.key)">
              {{ scope.row[items.field]&&scope.row[items.field].name?scope.row[items.field].name:'选择上课门店' }}
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!--排课计划-->
    <el-dialog title="门店列表" :visible.sync="dialogSitesVisible" width="600px" top="15vh" :append-to-body="true" @close="siteclose">
      <!-- <el-input v-model="listQuery.name" placeholder="请输入门店名称" style="width: 323px;">
        <el-button slot="append" icon="el-icon-search" @click="SearchData"></el-button>
      </el-input> -->
      <el-table ref="siteSingleTable" highlight-current-row :data="coachList" max-height="50vh" @current-change="handleCurrentChange">
        <el-table-column property="name" label="门店名称"></el-table-column>
        <el-table-column width="150" align="center" prop="type_name" label="门店类型"> </el-table-column>
        <el-table-column width="150" align="center" prop="open_status" label="是否营业">
          <template slot-scope="{ row }">
            {{ row.open_status === 1 ? '休息' : '营业' }}
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogSitesVisible=false">取 消</el-button>
        <el-button type="primary" @click="selectSite">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import lesson from '@/api/lesson/lesson' // 和数据交互相关写在api 方便复用
import commonList from '@/utils/commonList'
import api from '@/api/coach/coach' // 和数据交互相关写在api 方便复用

export default {
  name: 'LessonPlan',
  // 列绑定格式化器
  filters: {
  },
  mixins: [commonList],
  props: {
    coachId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      dialogSitesVisible: false,
      api,
      datess: [],
      tableData: [],
      coachList: [],
      total: 15,
      coursePlanLoading: false,
      currentSiteRow: null,
      currentXY: [],
      is_auto_plan_lesson: 0,
      auto_plan_lesson_type: 1,
      lastWeekPlanData: {}
    }
  },
  beforeMount() {
    this.getdates()
  },
  mounted() {
    this.getCoachList()
    this.getDatePlan()
    this.getLastWeekPlan()
  },
  methods: {
    handleCommand(command) {
      console.log(command)
    },
    getCoachList() {
      this.api.SiteList({
        coach_id: this.coachId
      }).then(response => {
        this.coachList = response.data
      })
    },
    getdates() {
      const now = new Date()
      const week = now.getDay()
      const weekLabels = ['一', '二', '三', '四', '五', '六', '日']
      const datess = [
        {
          field: 'time',
          week: '',
          date: ''
        }
      ]
      for (let i = 1; i <= 7; i++) {
        const date = new Date(now.getTime() - 24 * 60 * 60 * 1000 * (week - i))
        datess.push({
          field: 'week' + i,
          week: '周' + weekLabels[i - 1],
          date: date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
        })
      }
      this.$nextTick(() => {
        this.datess = datess
        // this.key2 = Math.random()
      })
    },
    siteShow(week, index) {
      this.api.SiteList({
        coach_id: this.coachId,
        time: this.tableData[index].time
      }).then(response => {
        this.currentXY = [index, week]
        this.coachList = response.data
        this.dialogSitesVisible = true
        this.$refs.siteSingleTable.setCurrentRow()
      })
    },
    siteclose() {
      this.listQuery = {
        page: 1,
        limit: 6,
        order: 'ASC',
        sort: 'order_no'
      }
      this.currentXY = []
      this.currentSiteRow = null
      this.$refs.siteSingleTable.setCurrentRow()
    },
    handleCurrentChange(val) {
      this.currentSiteRow = val
    },
    selectSite() {
      const i = this.currentXY[0]
      const j = 'week' + this.currentXY[1]
      this.tableData[i][j] = {
        id: this.currentSiteRow.id,
        name: this.currentSiteRow.name
      }
      this.$refs.siteSingleTable.setCurrentRow()
      this.dialogSitesVisible = false
      this.siteclose()
    },
    getDatePlan() {
      this.coursePlanLoading = true
      lesson.DatePlan({
        coach_id: this.coachId
      }).then(res => {
        this.auto_plan_lesson_type = Number(res.data.auto_plan_lesson_type)
        this.is_auto_plan_lesson = Number(res.data.is_auto_plan_lesson)
        this.formatData(res.data)
        this.coursePlanLoading = false
      }).catch(() => { this.coursePlanLoading = false })
    },
    formatData(res) {
      const start_time = Number(res.config.start_time.split(':')[0])
      const end_time = Number(res.config.end_time.split(':')[0])
      const result = []
      // this.dates.push({
      //   field: 'time',
      //   week: '',
      //   date: ''
      // })
      for (var i = start_time; i <= end_time; i++) {
        var time1 = i + ':00'
        var time2 = (parseInt(i) + 1) + ':00'
        if (i < 10) {
          time1 = '0' + i + ':00'
        }
        if ((parseInt(i) + 1) < 10) {
          time2 = '0' + (parseInt(i) + 1) + ':00'
        }
        result[i] = {
          time: time1 + ' ~ ' + time2,
          key: i
        }
        for (let j = 1; j <= 7; j++) {
          result[i]['week' + j] = {}
        }
      }
      this.tableData = result
      res.data.map(item => {
        const week = 'week' + item.week
        const time = Number(item.time.split(':')[0])
        if (!this.tableData[time]) {
          this.tableData[time] = []
        }
        this.tableData[time][week] = {
          name: item.site.name,
          id: item.site.id
        }
      })
    },
    getLastWeekPlan() {
      return lesson.LastWeekPlan({
        coach_id: this.coachId
      }).then(res => {
        this.lastWeekPlanData = res.data
      })
    },
    setLastWeekPlan() {
      this.formatData(this.lastWeekPlanData)
    },
    saveData() {
      return {
        coach_id: this.coachId,
        is_auto_plan_lesson: this.is_auto_plan_lesson,
        auto_plan_lesson_type: this.auto_plan_lesson_type,
        data: this.tableData
      }
    }
  }
}
</script>
<style>
/deep/ .column-custom {
	padding: 0px !important;
}

 /deep/ .el-table--border .el-table__cell:first-child .cell {
	padding: 0 !important;
}
.plan-header{

}
.header-div {
	height: 50px;
	position: relative;
}
.header-col1 {
	position: absolute;
	left: 0;
	bottom: 0;
}
.header-col2 {
	position: absolute;
	right: 0;
	top: 0;
}
.header-line {
	padding-left: 0;
	width: 1px;
	height: 150px;
	transform: rotate(-67deg); /*这里需要自己调整，根据线的位置*/
	-webkit-transform-origin: top;
	transform-origin: top;
	background-color: #fff;
  border-left:1px solid #e5e5e5;
}
.el-table::before{
  height:0 !important;
}

.course-plan-box{
  width: 1150px;
  margin:20px auto;
  height:60vh;
  /* overflow-y: scroll; */
}
.is-selected {
    color: #1989FA;
  }
  .course-all-list{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .pagination-container{
    padding-bottom:0 !important;
  }

</style>
